import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import enGB from './HN.Core.Filter.NPM.JS.en-GB.json';
import nbNO from './HN.Core.Filter.NPM.JS.nb-NO.json';
import nnNo from './HN.Core.Filter.NPM.JS.nn-NO.json';
export const getResources = (language) => {
    switch (language) {
        case LanguageLocales.ENGLISH:
            return enGB;
        case LanguageLocales.NORWEGIAN_NYNORSK:
            return nnNo;
        case LanguageLocales.NORWEGIAN:
        default:
            return nbNO;
    }
};
